import ApplicationController from "application_controller.js";
import Toast from "bootstrap/js/dist/toast";

export default class extends ApplicationController {
  static values = {
    autoshow: { type: Boolean, default: true },
  };

  debug = false;

  connect() {
    this.log_function("connect");

    this.toastInstance = Toast.getOrCreateInstance(this.element);

    if (this.autoshowValue) {
      this.toastInstance.show();
    }
  }

  disconnect() {
    this.log_function("disconnect");

    this.toastInstance.dispose();
  }
}
